<template lang="pug">
.main
  app-modal-redefinirSenha(v-if="modalIsOpen" @closeModal="closeModalRedefinirSenha")
  el-card.box-card
    validation-observer(ref='observer' tag='form')
      form(@keyup.enter="logar()")
        img.logo(src="@/assets/images/logo.png")

        .item
          validation-provider(rules="required|cpf_cnpj", v-slot="{ errors }" mode="lazy")
            el-input.input(
              :class="{'erro' : errors.length}",
              placeholder="CPF/CNPJ",
              v-model="login"
              v-mask="['###.###.###-##', '##.###.###/####-##']",
              masked="true",
            )
            span.help.erro {{ errors[0] }}

        .item
          validation-provider(rules="required", v-slot="{ errors }" mode="lazy" )
            el-input.input(
              :class="{'erro' : errors.length}",
              placeholder="Senha",
              v-model="senha"
              type="password",
            )
            span.help.erro {{ errors[0] }}

        .item
          el-button.full-width(
            @click="logar()",
            :disabled="loading",
            type="success"
          )
            span(v-if="!loading") Login
            i(v-else).el-icon-loading

      .buttons
        el-button(
          @click="openModalRedefinirSenha()",
          type="text"
        )
          span Redefinir senha
        //- el-button(
        //-   @click="criarConta()",
        //-   type="text"
        //- )
        //-   span Criar conta

</template>

<script>
import { mapActions } from 'vuex';
import AppModalRedefinirSenha from '@/components/AppModalRedefinirSenha';
import AppNotificacao from '@/components/mixins/AppNotificacao';

export default {
  name: 'Login',

  components: {
    AppModalRedefinirSenha,
  },

  mixins: [AppNotificacao],

  data() {
    return {
      login: '',
      senha: '',
      loading: false,
      loginError: false,
      senhaError: false,
      modalIsOpen: false,
    };
  },

  async mounted() {
    if (await this.isAutenticado()) this.$router.push('/selecionarModulo');
  },

  methods: {
    ...mapActions({
      loginPortalSeguranca: 'auth/loginPortalSeguranca',
      isAutenticado: 'auth/isAutenticado',
      verificarSenha: 'auth/verificarSenha',
      logout: 'auth/logout',
    }),

    async logar() {
      if (!(await this.$refs.observer.validate())) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.PREENCHA_TODOS_CAMPOS
        );
        return;
      }

      try {
        await this.loginPortalSeguranca({
          login: this.login,
          senha: btoa(this.senha),
        });

        const verificarSenhaResponse = await this.verificarSenha({
          login: this.login,
          senha: btoa(this.senha),
        });

        if (verificarSenhaResponse.message === 'Senha expirada') {
          this.logout();
          this.$router.push({ name: 'cadastrarSenha', params: { codigo: verificarSenhaResponse.codigoAcesso } });
        } else {
          this.$router.push({ name: 'selecionarModulo' });
        }
      } catch (err) {
        const { messageTitle, message } = err;
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          messageTitle || 'Erro',
          message || 'Erro ao fazer login.'
        );
      }
    },
    
    openModalRedefinirSenha() {
      this.modalIsOpen = true;
    },

    closeModalRedefinirSenha() {
      this.modalIsOpen = false;
    },

    criarConta() {
      this.$router.push({
        name: 'cadastroUsuario',
        params: {
          tipo: 'externo',
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  justify-content: center;
  height: 100;
  padding: 9%;
}

.box-card {
  width: 600px;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.logo {
  width: 30%;
  height: 30%;
  display: block;
  margin: 0 auto;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.item {
  padding: 10px 0px;
}
</style>
